import React, { Component } from "react"
import PropTypes from "prop-types"
import Multiselect from "react-select"

class MultiSelectCategories extends Component {

  static propTypes = {
    categories: PropTypes.array,
    selected_categories: PropTypes.array,
    onCategoryChange: PropTypes.func,
    getSelectedCategoriesList: PropTypes.func
  }

  state = {
    categories: [],
    selected_categories: []
  }

  componentDidMount() {
  }

  onCategoryChange = (category) => {
    this.props.onCategoryChange(category)
  }

  onSubmit = (event) => {
    return false;
  }

  render() {
    const { categories, selected_categories, getSelectedCategoriesList } = this.props
    return (
      <Multiselect
        isMulti={true}
        className={"select2"}
        value={getSelectedCategoriesList(categories, selected_categories)}
        options={categories}
        onChange={this.onCategoryChange}
      />
    )
  }
}

export default MultiSelectCategories
